import { paramMessage } from '../constants/parameterNames';
import { getParamValue } from '../helpers/parameter.accessors';


const description = "Writes a message to the logging system";

const requiredParameters = {
    [paramMessage]: {
        description: 'The message to log',
    }
}

function WriteLog({ logging }) {
    function execute({ parameters }) {
        const message = getParamValue(parameters, paramMessage);

        logging.logInfo(message);

        return `[${new Date().toISOString()}] ${message}`;
    }

    return {
        description,
        requiredParameters,
        execute,
    };
}


export default WriteLog;